import { Component, Inject } from '@angular/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-companies-test-link',
    templateUrl: './companies-test-link.component.html',
    styleUrls: ['./companies-test-link.component.scss'],
    standalone: false
})
export class CompaniesTestLinkComponent {

  constructor(
    @Inject(NZ_MODAL_DATA) public data: any,
    private dialogRef: NzModalRef<CompaniesTestLinkComponent>
  ) { }

  close(): void {
    this.dialogRef.close();
  }

}
